<!--历史工单列表查询-->
<template>
	<div slot="body" style="width: 100%;height: 100%;flex-direction: column;overflow-x: hidden;" class="flexStart custom-scrollbar">
		<div class="filterDiv">
			<div>
				<span>筛选条件:</span>
				<p v-for="item in filterList" @click="nowFilter[item.id] = !nowFilter[item.id],openFilter=true" :class="{isCheck:nowFilter[item.id]}">{{item.name}}</p>
				<iconButton icoName="wedoButton/search.png" buttonText="查询" @buttonClick="seachOrder"></iconButton>
				<iconButton v-show='nowFilter.orderGroup || nowFilter.state || nowFilter.priority ||nowFilter.startTime ||nowFilter.userList 
					||nowFilter.creatorIds ||nowFilter.nodeUsers ||nowFilter.participants' :icoName="openFilter?'wedoButton/delete.png':'wedoButton/add.png'" :buttonText="openFilter?'收起筛选':'显示筛选'" @buttonClick="openFilter = !openFilter" style="position: absolute;right: 10px;"></iconButton>
			</div>
			<div v-show="nowFilter.orderGroup && openFilter">
				<span>工单分组:</span>
				<p v-for="item in $store.orderGroupStore.getters.getOrderGroupTree" @click="orderGroupIds = [item.groupId]" :class="{isCheck:orderGroupIds.includes(item.groupId)}">{{item.name}}</p>
			</div>
			<div v-show="nowFilter.state && openFilter">
				<span>工单状态:</span>
				<p v-for="item in $store.orderStore.state.historyStateList" @click="nowStatus = item.value" :class="{isCheck:item.value == nowStatus}">{{item.name}}</p>
			</div>
			<div v-show="nowFilter.priority && openFilter">
				<span>优先级:</span>
				<p v-for="item in $store.orderGroupStore.state.priorityList" @click="nowPriority = item.value" :class="{isCheck:item.value == nowPriority}">{{item.name}}</p>
			</div>
			<div v-show="nowFilter.startTime && openFilter">
				<span v-show="nowFilter.startTime">开始时间:</span>
				<datePicker v-show="nowFilter.startTime" class="marginLeft" dateType="dateTime" :initDate="startTime" @checkDate="startTime = $event"></datePicker>
				<span v-show="nowFilter.startTime">~</span>
				<datePicker v-show="nowFilter.startTime" class="marginLeft" dateType="dateTime" :initDate="endTime" @checkDate="endTime = $event"></datePicker>
			</div>
			<div v-show="nowFilter.userList && openFilter">
				<span>参与人:</span>
				<p @click="addUsers('userList')" :class="{waitForPicker:userList.length == 0}" :title="getUserNameFromList(userList)" style="text-overflow: ellipsis;max-width: 70%;overflow: hidden;white-space: nowrap;">{{getUserNameFromList(userList)}}</p>
				<p style="color: silver;" @click="userList = []">清空</p>
			</div>
			<div v-show="nowFilter.creatorIds && openFilter">
				<span>发起人:</span>
				<p @click="addUsers('creatorIds')" :class="{waitForPicker:creatorList.length == 0}" :title="getUserNameFromList(creatorList)" style="text-overflow: ellipsis;max-width: 70%;overflow: hidden;white-space: nowrap;">{{getUserNameFromList(creatorList)}}</p>
				<p style="color: silver;" @click="creatorList = []">清空</p>
			</div>
			<div v-show="nowFilter.nodeUsers && openFilter">
				<span>负责人:</span>
				<p @click="addUsers('nodeUsers')" :class="{waitForPicker:nodeUserList.length == 0}" :title="getUserNameFromList(nodeUserList)" style="text-overflow: ellipsis;max-width: 70%;overflow: hidden;white-space: nowrap;">{{getUserNameFromList(nodeUserList)}}</p>
				<p style="color: silver;" @click="nodeUserList = []">清空</p>
			</div>
			<div v-show="nowFilter.participants && openFilter">
				<span>抄送人:</span>
				<p @click="addUsers('participants')" :class="{waitForPicker:participantList.length == 0}" :title="getUserNameFromList(participantList)" style="text-overflow: ellipsis;max-width: 70%;overflow: hidden;white-space: nowrap;">{{getUserNameFromList(participantList)}}</p>
				<p style="color: silver;" @click="participantList = []">清空</p>
			</div>
		</div>
		<infoList style="height: calc(100% - 50px);width: 100%;" ref="infoList" @checkItem="nowOrder = $event" :columns='columns' :dataList="nowPage" :pageLen='pageLen' :totalSize="totalSize" @selectPage="selectPage" :fillAll="true">
			<div slot="control" slot-scope="slotProps" v-show="slotProps.item != undefined">
				<u class="intoButton" @click.stop="intoOrder(slotProps.item)" style="margin-right: 10px;">进入</u>
				<u class="intoButton" @click.stop="copyOrder(slotProps.item)" v-show="slotProps.item != undefined" style="margin-right: 10px;">克隆</u>
				<u class="intoButton" @click.stop="invalidOrder(slotProps.item)" v-show="slotProps.item != undefined">删除</u>
			</div>
		</infoList>
	</div>
</template>

<script>
	import singleSelection from '@/components/module/selection/base/singleSelection.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import datePicker from '@/components/module/datePicker/base/datePicker.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	export default {
		components: {
			infoList,
			singleSelection,
			multipleSelection,
			datePicker,
			iconButton
		},
		props: {},
		data() {
			return {
				nowStatus: undefined,
				nowPriority: undefined,
				nowFilter: {
					orderGroup: false,
					state: false,
					priority: false,
					startTime: false,
					userList: false,
					creatorIds: false,
					nodeUsers: false,
					participants: false,
				},
				openFilter: true,
				filterList: [{
					name: '工单分组',
					id: 'orderGroup'
				}, {
					name: '工单状态',
					id: 'state'
				}, {
					name: '优先级',
					id: 'priority'
				}, {
					name: '开始时间',
					id: 'startTime'
				}, {
					name: '参与人',
					id: 'userList'
				}, {
					name: '发起人',
					id: 'creatorIds'
				}, {
					name: '负责人',
					id: 'nodeUsers'
				}, {
					name: '抄送人',
					id: 'participants'
				}],
				//当前选中的分组的id数组，单人版本只允许单个
				orderGroupIds: [],
				userList: [],
				creatorList: [],
				nodeUserList: [],
				participantList: [],
				pageLen: 100,
				nowOrder: [],
				nowIndex: 0,
				orderListByIndex: [], //每一页的记录,修改查询内容后查询就会清空
				startTime: new Date(),
				endTime: new Date(),
				totalSize: 0,
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.seachOrder()
		},
		destroyed() {},
		computed: {
			myId() {
				return this.$store.userStore.state.nowUserInfo.id
			},
			userTree() {
				return this.$store.userStore.getters.getUnitUserTree
			},
			nowPage() {
				var list = this.orderListByIndex[this.nowIndex]
				if(list == undefined) {
					return []
				}
				return list
			},
			columns() {
				var baseList = [{
					name: '单号',
					key: 'orderId',
					weight: 1.2
				}, {
					name: '名称',
					key: 'title',
					weight: 1.4,
				}, {
					name: '创建人',
					key: 'creatorName'
				}, {
					name: '分组',
					key: 'groupId',
					format: item => {
						return getValueIfNoNull(this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item), {
							name: '未分组'
						}).name
					}
				}, {
					name: '优先级',
					key: 'groupId',
					format: item => {
						var group = this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item)
						if(group == undefined) {
							return '--'
						}
						var priority = this.$store.orderGroupStore.getters.getPriorityByValue(group.priority)
						return getValueIfNoNull(priority, {
							name: '--'
						}).name
					}
				}, {
					name: '创建时间',
					key: 'createTime',
					format(item) {
						return new Date(item).formatByTime()
					},
					weight: 1.4,
				}]
				baseList.insert(2, {
					name: '状态',
					key: 'status',
					format: item => {
						return this.$store.orderStore.getters.getStateNameByStatus(item)
					}
				})
				baseList.push({
					name: '开始时间',
					key: 'startTime',
					format(item) {
						return new Date(item).formatByTime()
					},
					weight: 1.4,
				})
				baseList.push({
					name: '完成时间',
					key: 'endTime',
					format(item) {
						return new Date(item).formatByTime()
					},
					weight: 1.4,
				})
				baseList.push({
					name: '最后编辑时间',
					key: 'updateTime',
					format(item) {
						return new Date(item).formatByTime()
					},
					weight: 1.4,
				})
				baseList.push({
					name: '操作',
					type: 'slot',
					key: 'control'
				})
				return baseList
			},
			getUserNameFromList() {
				return list => {
					var name = list.map(item => item.username).join(' , ')
					if(name.length == 0) {
						return '请选择'
					}
					return name
				}
			},
		},
		watch: {},
		methods: {
			selectPage(index) {
				this.nowIndex = index
				if(isempty(this.nowPage)) {
					this.seachOrder()
				}
			},
			getAllUserList(list) {
				var resultList = []
				for(var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					if(item.type == 'PcmUser') {
						resultList.push(item)
					} else {
						//递归找下级
						resultList.addAll(this.getAllUserList(item.next))
					}
				}
				return resultList
			},
			addUsers(type) {
				switch(type) {
					case 'userList':
						this.$dialogMethod.openMultipleSelectionDialog('参与人', this.userTree, this.userList.map(item => item.userId),
							respon => {
								//一次可以添加多个
								this.userList = respon
							})
						break
					case 'participants':
						this.$dialogMethod.openMultipleSelectionDialog('抄送人', this.userTree, this.participantList.map(item => item.userId),
							respon => {
								//一次可以添加多个
								this.participantList = respon
							})
						break
					case 'creatorIds':
						this.$dialogMethod.openMultipleSelectionDialog('发起人', this.userTree, this.creatorList.map(item => item.userId),
							respon => {
								//一次可以添加多个
								this.creatorList = respon
							})
						break
					case 'nodeUsers':
						this.$dialogMethod.openMultipleSelectionDialog('负责人', this.userTree, this.nodeUserList.map(item => item.userId),
							respon => {
								//一次可以添加多个
								this.nodeUserList = respon
							})
						break
				}
			},
			seachOrder() {
				//管理员查询单位下所有用户参与的工单，可根据条件过滤
				var userList = undefined
				if(this.nowFilter.userList) {
					userList = this.userList.map(item => item.userId).join(',')
				} else {
					this.userList = this.getAllUserList(this.userTree)
					userList = this.userList.map(item => item.userId).join(',')
				}
				var creatorIds = undefined
				if(this.nowFilter.creatorIds) {
					creatorIds = this.creatorList.map(item => item.userId).join(',')
				}
				var nodeUsers = undefined
				if(this.nowFilter.nodeUsers) {
					nodeUsers = this.nodeUserList.map(item => item.userId).join(',')
				}
				var participants = undefined
				if(this.nowFilter.participants) {
					participants = this.participantList.map(item => item.userId).join(',')
				}
				//排除多余的检查项
				var orderGroupIds = undefined
				if(this.nowFilter.orderGroup) {
					orderGroupIds = this.orderGroupIds.join(',')
				}
				var nowStatus = undefined
				if(this.nowFilter.state) {
					nowStatus = this.nowStatus
				} else {
					nowStatus = "BreakOff,Done,OvertimeDone"
				}
				var nowPriority = undefined
				if(this.nowFilter.priority) {
					nowPriority = this.nowPriority
				}
				var startTime = undefined
				if(this.nowFilter.startTime) {
					startTime = this.startTime.getTime()
				}
				var endTime = undefined
				if(this.nowFilter.startTime) {
					endTime = this.endTime.getTime()
				}
				//判断工单类型
				var orderType = 'Order'
				this.$api.orderApi.searchByType(this.nowIndex + 1, this.pageLen, orderGroupIds, orderType, nowStatus, nowPriority,
					creatorIds, nodeUsers, participants, startTime, endTime, userList, respon => {
						this.totalSize = respon.total
						this.$set(this.orderListByIndex, this.nowIndex, respon.dataList)
						if(orderType == 'OrderTemplate') {
							this.$store.orderStore.commit('getOrderTemplateList')
						}
					})
			},
			intoOrder(order) {
				//进入工单
				this.$store.orderStore.commit('setNowOrder', order)
				this.$router.push('/dealOrder')
			},
			invalidOrder(order) {
				this.$dialogMethod.openAgreeDialog("删除工单", "是否确定删除 " + order.title, () => {
					this.$api.orderApi.removeByOrderIds(order.orderId, respon => {
						if(respon.length > 0) {
							this.$dialogMethod.showMessage('当前工单不允许被删除!')
						} else {
							this.nowOrder = []
							this.seachOrder()
							var list = this.orderListByIndex[this.nowIndex]
							this.$set(list, list.findIndex(item => {
								return item.orderId == order.orderId
							}), order)
							this.$dialogMethod.showMessage('删除成功!')
						}
					})
				})
			},
			copyOrder(order) {
				//进入工单
				this.$store.orderStore.commit('setCopyOrderId', order.id)
				this.$router.push('/copyOrder')
			},
		}
	}
</script>

<style scoped>
	.marginLeft {
		margin: 0 10px;
	}
	
	.intoButton {
		color: #DA7800;
		text-align: center;
		cursor: pointer;
	}
	
	.filterDiv {
		background: #EAEEF2;
		width: calc(100% - 20px);
		padding: 0 10px;
	}
	
	.filterDiv>div {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		position: relative;
		/* border-bottom: silver 1px dashed; */
	}
	
	.filterDiv>div>p {
		font-size: .12rem;
		padding: 2px 5px;
		cursor: pointer;
		margin: 5px 10px;
		border-radius: 10px;
	}
	
	.filterDiv>div>p.isCheck {
		color: white;
		background: #DA7800;
	}
	
	.filterDiv>div>span {
		font-size: .12rem;
		padding: 5px 10px;
		color: #7f7f7f;
		min-width: 60px;
	}
	
	.filterDiv>>>.wedoButton-body {
		background: silver;
	}
</style>